// $(document).ready(function () {
//   // Open Notify Popup
//   $(".sold_out_product_notify, #notifyMeBtn").on("click", function () {
//     var variantIdAttr = $(this).attr("variant-id"); 
//     var customerEmail = $(this).attr("customer-email"); 
//     var customerPhone = $(this).attr("customer-phone");
//     console.warn("customerEmail", customerEmail);
    

// if (!customerEmail) {
//   $("#loginPopup").fadeIn();
// } else {
//   if (variantIdAttr && variantIdAttr.startsWith("[")) {
//     var variantIds = variantIdAttr.replace(/[\[\]\s]/g, "").split(",");
//     $("#outOfStockVariants").empty();
    
//     Promise.all(
//       variantIds.map(id =>
//         fetch(`/variants/${id}.js`).then(res => res.json())
//       )
//     )
//     .then(variants => {
//       variants.sort((a, b) => Number(a.title) - Number(b.title));

//       variants.forEach(variant => {
//         var optionHtml = `
//           <div class="out-of-stock-option">
//             <label>
//               <input type="radio" class="notify-variant" name="notify_variant" value="${variant.title}">
//               ${variant.title}
//             </label>
//           </div>
//         `;
//         $("#outOfStockVariants").append(optionHtml);
//       });
//     })
//     .catch(err => console.error("Variant fetch error", err));
//   }

//   $("#notifyMePopup").css("display", "block");
// }

//   });

//   $(".close-popup").on("click", function () {
//     $("#notifyMePopup").css("display", "none");
//   });

//   // ✅ Fix: delegated binding for notifySubmit
//   $(document).on("click", "#notifySubmit", function () {
//     var customerEmail = $(".sold_out_product_notify").attr("customer-email"); 
//     var customerPhone = $(".sold_out_product_notify").attr("customer-phone");
//     var ProductId = $(".sold_out_product_notify").attr("productid");
//     var notifydate = $(".sold_out_product_notify").attr("notify-date");

//     var selectedVariants = [];
//     $(".notify-variant:checked").each(function () {
//       selectedVariants.push($(this).val());
//     });

//     if (selectedVariants.length > 0) {
//       showPopup("notifyPopup", "You will be notified for: " + selectedVariants.join(", "));

//       if (customerEmail) {
//         fetch("https://shopify.wforwoman.com/notify/adddata", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             email: customerEmail,
//             phone: customerPhone || "",
//             variantids: selectedVariants,
//             productid: ProductId,
//             notify_date: notifydate
//           })
//         })
//           .then(async (response) => {
//             const text = await response.text();
//             try {
//               const data = JSON.parse(text);
//               showPopup("notifyPopup", "We’ve received your request. You’ll be notified soon!");
//               $("#notifyMePopup").fadeOut();
//             } catch (err) {
//               console.error("JSON parse error:", err, text);
//               showPopup("notifyPopup", "Server error. Please try again.");
//             }
//           })
//           .catch(error => {
//             console.error("Fetch error:", error);
//             showPopup("notifyPopup", "Something went wrong, please try again later.");
//           });
//       } else {
//         $("#loginPopup").fadeIn();
//       }
//     } else {
//       showPopup("notifyPopup", "Please select at least one out-of-stock size.");
//     }
//   });


//   $(".popup-close").click(function () {
//     $("#loginPopup").fadeOut();
//   });

//   function showPopup(popupId, message) {
//     var popup = document.getElementById(popupId);
//     popup.querySelector("p").textContent = message;
//     popup.style.display = "block";
//     setTimeout(function () {
//       popup.style.display = "none";
//     }, 3000);
//   }
// });




$(document).ready(function () {
  // --- Helpers ---
  function getWishlist() {
    var list = localStorage.getItem("wishlist");
    return list ? JSON.parse(list) : [];
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
  }

  var ProductId = $(".before_wish").attr("productid");
  var wishlistdate = $(".before_wish").attr("wisthlist-date");
  var customerPhone = $(this).attr("customer-phone");

  function updateWishlistAPI(email, customerPhone, list) {
    const payload = {
      useremail: email || "Guest",
      variantids: list.map(item => item.variantId), // ✅ send only variant IDs
      phone: customerPhone || "",
      productid: ProductId,
      wishlist_date: wishlistdate
    };

    fetch("https://shopify.wforwoman.com/Wishlist/addwishlistdata", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const text = await response.text();
        try {
          const data = JSON.parse(text);
          console.log("Wishlist updated:", data);
        } catch (err) {
          console.error("JSON parse error:", err, text);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }

  // --- Sync localStorage with API on first load ---
  $(".before_wish").each(function () {
    var customerEmail = $(this).attr("customer-email");

    if (customerEmail) {
      fetch(`https://shopify.wforwoman.com/Wishlist/getdatabyuser/${customerEmail}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((result) => {
          console.warn("responseis", result);
          if (result.success) {
            var apiItems = result.data.variantid.map(function (item) {
              return {
                variantId: item.id.replace("gid://shopify/ProductVariant/", ""),
                sku: item.sku,
                price: item.price,
                compareAtPrice: item.compareAtPrice,
                available: item.availableForSale,
                qty: item.inventoryQuantity,
                productId: item.product.id.replace("gid://shopify/Product/", ""),
                productTitle: item.product.title,
                productHandle: item.product.handle,
                productImage: item.product.images[0].url,
                variantTitle: item.title
              };
            });

            saveWishlist(apiItems);
          }
        })
        .catch((err) => console.error("API Fetch Error:", err));
    }
  });

  // --- Wishlist Button Click ---
  $(document).on("click", ".cstm_wishlist_icon", function () {
    var before = $(this).find(".before_wish");
    var after = $(this).find(".after_wish");
    var variantId = before.attr("variant-id");
    var customerEmail = before.attr("customer-email");
    var customerPhone = before.attr("customer-phone");
    var productId = before.attr("productid");
    var productTitle = before.attr("product-title");
    var productHandle = before.attr("product-handle");
    var price = before.attr("product-price");
    var variantTitle = before.attr("variant-title");
    var productImage = before.attr("product-image");

    if (!customerEmail) {
      $("#loginPopup").fadeIn();
      return;
    }

    var wishlist = getWishlist();
    var exists = wishlist.find((item) => item.variantId === variantId);

    if (exists) {
      // Remove
      wishlist = wishlist.filter((item) => item.variantId !== variantId);
      before.show();
      after.hide();
      showPopup("wishlistPopup", "Removed from Wishlist ❌");
    } else {
      // Add full object
      wishlist.push({
        variantId,
        productId,
        productTitle,
        productHandle,
        productImage,
        price,
        variantTitle
      });
      before.hide();
      after.show();
      showPopup("wishlistPopup", "Added to Wishlist ❤️");
    }

    saveWishlist(wishlist);
    updateWishlistAPI(customerEmail, customerPhone, wishlist);
  });

  // --- Initial UI Setup ---
  $(".before_wish").each(function () {
    var before = $(this);
    var after = before.siblings(".after_wish");
    var variantId = before.attr("variant-id");

    var wishlist = getWishlist();

    var exists = wishlist.find((item) => item.variantId === variantId);
    if (exists) {
      before.hide();
      after.show();
    } else {
      after.hide();
      before.show();
    }
  });

  // --- Reusable Popup Function ---
  function showPopup(popupId, message) {
    var popup = document.getElementById(popupId);
    if (popup) {
      popup.querySelector("p").textContent = message;
      popup.style.display = "block";

      setTimeout(function () {
        popup.style.display = "none";
      }, 3000); // auto hide after 3 sec
    }
  }
});

$(document).on("click", "label[current-variant-id]", function () {
  var newVariantId = $(this).attr("current-variant-id");

  // Wishlist icon ko update karo
  $(".before_wish").attr("variant-id", newVariantId);
});

$(document).on("click", ".cstm__size_coll a", function (e) {
  e.preventDefault();

  var newVariantId = $(this).data("attr");   // clicked variant-id
  var cardWrapper = $(this).closest(".cstm__card_bottom"); // product card ka wrapper

  // ✅ Update Add to Cart button
  cardWrapper.find(".cstm__card_button").attr("data-id", newVariantId);

  // ✅ Update Wishlist icon (before_wish)
  cardWrapper.closest(".grid__item, .product-card, [productid]").find(".before_wish").attr("variant-id", newVariantId);
});




 $('body').on('click', '.wishlist_add_to_cart', function() {
    var id = $(this).attr('variant_id');
    var $button = $(this);
    if (!id) {
    } else {
      $button.addClass('loading');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: id,
          quantity: 1,
        },
        dataType: 'json',
        success: function(response) {
          $.getJSON('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble').then(sections => {
            const minicart = document.querySelector('mini-cart');
            response.sections = sections;
            minicart.renderContents(response);
            $button.removeClass('loading');
            $('.main__cart_card').hide();
          });
        },
        error: function() {
          console.log('There was an error adding the item to the cart.');
          $button.removeClass('loading');
          $('.main__cart_card').hide();
        }
      });
    }
  });




